import { hc_ds } from './_datastore.js';
import { hc_utils } from './_utils.js';
import { hc_templates } from './_templates.js';
import { hc_payment } from './_payment-summaries.js';

(function(){
	'use strict';

	// Global variables and functions
	let hccosp = {
		'fn': {},
		'templates': {},
		'vars': {
			'notifier': document.getElementById('hccosp-notifier'),
			'session': 'hccds',
			'proxy': ""
		},
		'data': {}
	};

	// submit actions for forms
	hccosp.formActions = {
		"lookup": function(e){
			// The lookup function is intended to extract form info to search a collection dynamically
			e.preventDefault();
			let form = e.target;
			let formConfig = form.dataset;
			hc_utils.loader(form, true);
			// FormData converted to JSON
			let formData = JSON.parse(JSON.stringify(Object.fromEntries(new FormData(form))));
			let mergedFormData = hc_utils.mergeFormValues(formData);
			formConfig.dsId = mergedFormData;
			let settings = {
				"conf": formConfig,
				"data": formData
			}
			// Perform the DS search
			hc_ds.fn.getData(settings).then((response) => {
				// set sessionStorage
				var settings = {
					"dsId": response.dsId,
					"id": response.id,
					"collection": formConfig.collection,
					"type": formConfig.type
				}
				hc_utils.setSessionStorage(hccosp.vars.session, settings);
				window.location = form.action;
            }).catch((error) => {
				hc_utils.loader(form, false);
				hc_utils.notifier(hc_templates.notifiers.general.record_error);
			});;
		},
		"sendReceipt": function(e){
			e.preventDefault();
			let form = e.target;
			let formConfig = form.dataset;
			hc_utils.loader(form, true);
			// FormData converted to JSON
			let formData = new FormData(form);
			fetch(formConfig.target, {
				method: "POST",
				body: formData
			}).then((formResponse) => formResponse.json()).then(res => {
				console.log("Request complete! response:", res);
				//then redirect
				window.location = form.action;
			});
		}
	};

	/**
	* ===================================================
	* OSP Initialiser
	* ===================================================
	*/
	hccosp.init = function(){
		// init DS
		hc_ds.fn.init();

		// payment summary screen
		let paymentSummary = document.querySelector('.hccosp-payment-summary') || null;
		if(paymentSummary){
			hc_payment.summary(paymentSummary);
		}
		// payment success screen
		let paymentSuccess = document.querySelector('.hccosp-payment-success') || null;
		if(paymentSuccess){
			hc_payment.success(paymentSuccess);
		}
		// payment cancelled screen
		let paymentCancelled = document.querySelector('.hccosp-payment-cancelled') || null;
		if(paymentCancelled){
			hc_payment.cancelled(paymentCancelled);
		}
		// payment failed screen
		let paymentFailed = document.querySelector('.hccosp-payment-failed') || null;
		if(paymentFailed){
			hc_payment.failed(paymentFailed);
		}


		//
		// event listeners
		//

		let forms = document.querySelectorAll('.hccosp-form');
		forms.forEach(function(form){
			let formType = form.dataset.formtype || null;
			if(formType && formType == 'lookup') {
				form.addEventListener('submit', hccosp.formActions.lookup);
			}
			if(formType && formType == 'receipt') {
				form.addEventListener('submit', hccosp.formActions.sendReceipt);
			}
		});
		

		//
		// end event listeners
		//

	}

	// wait for DOMContentLoaded before starting up OSP
	document.addEventListener("DOMContentLoaded", function () {
		//console.log(process.env.DS_serviceURL);
        hccosp.init();
    });

	// Make hccosp variable available to the console for debugging
	window.hccosp = hccosp;
	window.hc_ds = hc_ds;
	window.hc_utils = hc_utils;

}());